module.exports = __webpack_public_path__ + "static/media/sales_recap.a39fafaf.png";